/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/awardFinder/resources/js/homePage/listViewUtil.js
*    TO   --> ./webapps/homepage-web/src/main/assets/js/home/award-finder/list-view-util.js
**/

var ListViewUtil = {};

ListViewUtil = (function() {

	var $_list = $('#listView');
	var $_enterSearchPrompt = $('#enterSearch');
	var $_sortContainer = $('#sortContainer');
	var $sidebar = $('#sidebar');
	var $_sidebarTab = $('#slide-tab');

	function hideRow(airportCode) {
		var row = $('#listView').children('.row-'+airportCode);
		row.hide();
	}

	function showRow(airportCode) {
		var row = $('#listView').children('.row-'+airportCode);
		row.show();
	}

	function resetList() {
		$sidebar.find('.hide-on-search').hide();
		showTitle('searching');
		openSidebar();
		showLoader();
		$_enterSearchPrompt.hide();
		$_list.html('');
		HomepageSortUtil.reset();
	}

	function updateListAfterSearch() {
		if($('#sidebar .list-row').length > 2) {
			$('#sortContainer').show();
		}
		ListViewUtil.updateSidebarHeight();
		showTitle('search-results');
        $('#loader').hide();
	}

	function addResultsToList(airports) {
		for(var i=0; i<airports.length; i++) {
			var airport = airports[i];
			addToList(airport.airport, airport.miles, airport.upshow);
		}
		updateListAfterSearch();
	}
	function addToList(airport, miles, upshow) {
		$_list.append(createListRowDiv(airport, miles, upshow));
		var $newRow = $_list.find('.list-row:last');
		$newRow.not('a').click(function() {
    		MapUtil.panAndShowInfobox(airport.code);
    	});
		$newRow.find('a.book-now, a.hold-reservation-list').click(function(e) {
			var PRIMARY_CLICK = 1;
        	/* don't show interstitial if opened in new tab */
        	if(e.which === PRIMARY_CLICK) {
        		aaWait.start();
        	}
		});
	}

	function showTitle(id) {
		$('#sidebar-title span').hide();
		$('#sidebar-title').find('.title-'+id).show().attr('tabindex','0').blur().focus();
	}

	var createListRowDiv = function(airport, miles, upshow) {
		var milesComma = CommonUtil.commaSeparateNumber(miles);
		var $div = $('#list-row-dummy').clone();
		$div.find('.list-row').addClass("row-" + airport.code);
		$div.find('.city-name .city').text(airport.cityName);

		var countryText = (airport.countryName == 'United States') ? airport.stateName : airport.countryName;
        if(airport.countryName === '' || (airport.countryName.indexOf('Hong Kong') >= 0) || (airport.countryName.indexOf('Taiwan') >= 0) || (airport.countryName.indexOf('Macau') >= 0)) {
    		$div.find('.city-name .country').text('');
        } else {
    		$div.find('.city-name .country').text(countryText);
        }
		$div.find('.city-name .airport-code').text(airport.code);
		$div.find('.num-miles .num').text(milesComma);


		if(CommonUtil.displayBuyMiles(miles, upshow)) {
			$div.find('.list-row').addClass('upsell');
			$div.find('a.book-now').hide();
			$div.find('.buy-miles-list-container').show();
			$div.find('a.hold-reservation-list').attr('href', CommonUtil.generateQueryStringForBooking(airport.code));
		}
		else {
			$div.find('a.book-now').attr('href', CommonUtil.generateQueryStringForBooking(airport.code));
		}

		return $div.html();

	};

	function initializeSidebarHeightUpdater() {
		updateSidebarHeight();
    	$(window).resize(function() {
    		updateSidebarHeight();
    	});
    };

    function updateSidebarHeight() {
    	var $scroller = $('.scroll-container');
    	/*
    	 * height of whole window minus height where scroller starts ($scroller.offset().top)
    	 */
    	var height = $(window).height() - $scroller.offset().top;
		$scroller.css('height', height + 'px');
    };

    function sidebarOpen() {
    	return $_sidebarTab.hasClass('open');
    }

    function toggleSidebar() {
		if(sidebarOpen()) {
			closeSidebar();
		}
		else {
			openSidebar();
		}
	}

    function showLoader() {
		$('#loader').fadeIn();
	};

	function openSidebar() {
	    var sidebarHTML = '&laquo;<span class="hidden-accessible">' + AAcom.prototype.getProperty('openedTxt') + '</span>'
		$sidebar.animate({left:'0px'});
		$_sidebarTab.removeClass('closed').addClass('open');
		$_sidebarTab.html(sidebarHTML);
		$('#sidebar-title, #scroll-container').attr('tabindex','0');
	}

	function closeSidebar() {
        var sidebarHTML = '&raquo;<span class="hidden-accessible">' + AAcom.prototype.getProperty('closedTxt') + '</span>'
		$sidebar.animate({left:-$sidebar.outerWidth()});
		$_sidebarTab.removeClass('open').addClass('closed');
		$_sidebarTab.html(sidebarHTML);
        $('#sidebar-title, #scroll-container').removeAttr('tabindex');
	}

	return {
		addResultsToList : addResultsToList,
		resetList : resetList,
		showTitle : showTitle,
		initializeSidebarHeightUpdater : initializeSidebarHeightUpdater,
		updateSidebarHeight : updateSidebarHeight,
		showRow : showRow,
		hideRow : hideRow,
		sidebarOpen : sidebarOpen,
		toggleSidebar : toggleSidebar,
		openSidebar : openSidebar,
		closeSidebar : closeSidebar,
		$sidebar : $sidebar
	};

}());
